export default __webpack_public_path__ + "static/media/12.7376d4d4.mp3";